module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"inboundEdi":"Inngående EDI","outboundEdi":"Utgående EDI"},"en":{"inboundEdi":"Inbound Edi","outboundEdi":"Outbound Edi"}}')
  delete Component.options._Ctor
}
